import React from 'react';
import styled from 'styled-components';

type BadgeVariant = 'pending' | 'active' | 'complete';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
}

interface StyledBadgeProps {
  variant: BadgeVariant;
}

const getVariantStyles = (variant: BadgeVariant) => {
  switch (variant) {
    case 'pending':
      return {
        backgroundColor: '#FFC107',
        color: '#664d03'
      };
    case 'active':
      return {
        backgroundColor: '#28A745',
        color: 'white'
      };
    case 'complete':
      return {
        backgroundColor: '#17A2B8',
        color: 'white'
      };
    default:
      return {
        backgroundColor: '#FFC107',
        color: '#664d03'
      };
  }
};

const StyledBadge = styled.span<StyledBadgeProps>`
  display: inline-block;
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 5px;
  background-color: ${({ variant }: StyledBadgeProps) => getVariantStyles(variant).backgroundColor};
  color: ${({ variant }: StyledBadgeProps) => getVariantStyles(variant).color};
`;

const Badge: React.FC<BadgeProps> = ({ variant, children }) => {
  return <StyledBadge variant={variant}>{children}</StyledBadge>;
};

export default Badge; 